function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('./index.js').H} H
 */
import { thematicBreak } from './handlers/thematic-break.js';
import { list } from './handlers/list.js';
import { wrap } from './wrap.js';
/**
 * @param {H} h
 */

export function footer(h) {
  var footnoteById = h.footnoteById;
  var footnoteOrder = h.footnoteOrder;
  var index = -1;
  /** @type {Array.<ListItem>} */

  var listItems = [];

  while (++index < footnoteOrder.length) {
    var def = footnoteById[footnoteOrder[index].toUpperCase()];

    if (!def) {
      continue;
    }

    var marker = String(index + 1);

    var content = _toConsumableArray(def.children);
    /** @type {Link} */


    var backReference = {
      type: 'link',
      url: '#fnref' + marker,
      data: {
        hProperties: {
          className: ['footnote-back'],
          role: 'doc-backlink'
        }
      },
      children: [{
        type: 'text',
        value: '↩'
      }]
    };
    var tail = content[content.length - 1];

    if (tail && tail.type === 'paragraph') {
      tail.children.push(backReference);
    } else {
      // @ts-expect-error Indeed, link directly added in block content.
      // Which we do because that way at least the handlers will be called
      // for the other HTML we’re generating (as markdown).
      content.push(backReference);
    }

    listItems.push({
      type: 'listItem',
      data: {
        hProperties: {
          id: 'fn' + marker,
          role: 'doc-endnote'
        }
      },
      children: content,
      position: def.position
    });
  }

  if (listItems.length === 0) {
    return null;
  }

  return h(null, 'section', {
    className: ['footnotes'],
    role: 'doc-endnotes'
  }, wrap([thematicBreak(h), list(h, {
    type: 'list',
    ordered: true,
    children: listItems
  })], true));
}